import HundredBricksAPIError from '../HundredBricksAPIError';
class AdvisorError extends HundredBricksAPIError {
}
export default AdvisorError;
